var $ = require('jquery');

var $navigation = $('.main-navigation'),
  $navigationBtn = $('.js-main-navigation__btn');

$navigationBtn.click(function(e) {
  if (e) {
    e.preventDefault();
  }

  $navigation.toggleClass('main-navigation--active');
  $navigationBtn.toggleClass('active');
});

var $franchiseEmail = $('.js-franchise-email'),
  $franchisePhone = $('.js-franchise-phone');

$franchiseEmail.click(function(e) {
  ga('send', 'event', 'Email Address', 'Click', $franchiseEmail.data('name'));
});

$franchisePhone.click(function(e) {
  ga('send', 'event', 'Contact Number', 'Click', $franchisePhone.data('name'));
});



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/franchise-navigation.js